import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Button, Typography } from "@mui/material";
import Card from '@mui/material/Card';
import Colors from "../../components/ui/Colors";
import { createManualInventory } from "../../utilityFunctions/WarehouseUtil";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

export default function ManualInventory(props) {
    const { loginUser } = props;
    let history = useHistory();
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        // Initialize component
    }, []);

    const handleCreateManualInventory = async () => {
        setLoading(true);
        const newManualInventory = await createManualInventory(loginUser.jwtToken);
        setLoading(false);

        if (!newManualInventory) {
            swal({
                title: "Error",
                text: "No se pudo crear el inventario manual. Por favor intente de nuevo.",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        swal({
            title: "Inventario Manual Creado",
            text: `Inventario manual creado exitosamente. ID: ${newManualInventory.id}`,
            icon: "success",
            buttons: "OK"
        }).then(() => {
            // Navigate to manual inventory entry page with the ID
            history.push({
                pathname: "/warehouse/manual-inventory-entry",
                state: {
                    manualInventoryId: newManualInventory.id
                }
            });
        });
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", backgroundColor: "#ededed" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: { xs: "start", sm: "center", md: "center" },
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                }}
            >
                {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
                    <Grid container sx={{ display: "flex", justifyContent: "center" }}>
                        <Grid item xs={12} sm={12} md={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Card sx={{ maxWidth: "600px", minWidth: { xs: "90%", sm: "60%", md: "400px" }, minHeight: "200px", borderRadius: "15px", marginTop: { xs: "20%", sm: "0%", md: "2rem" }, marginBottom: { xs: "1rem", sm: "1rem", md: "1rem" } }}>
                                <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: "2rem" }}>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", marginBottom: "2rem" }}>
                                        <Typography variant="h5">Crear Nuevo Inventario Manual</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
                                        <Typography variant="body1">
                                            Presione el botón para crear un nuevo inventario manual. 
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", marginTop: "1.8rem", marginBottom: "1rem" }}>
                                        <Button onClick={handleCreateManualInventory} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                                            Crear Inventario Manual
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                }
            </Box>
        </Box>
    );
} 